export enum RejectionReasons {
  ALGO_GENERIC_ERROR = 'algo_generic',
  PAYMENT_ERROR = 'payment_error',
  BACKEND_GENERIC_ERROR = 'backend_generic_error',
  ALGO_REBOOT = 'algo_reboot',
  FAILED_THREEDS = 'failed_3ds'
}
